import {dataSvg as Icon__small__dataSvg} from '../Icon__small/Icon__small--data.js'
import {dataSvg as Icon__xsmall__dataSvg} from '../Icon__xsmall/Icon__xsmall--data.js'

export var data = {
  name: 'data',
  category: 'icon',
  colorable: true,
  svg: Icon__small__dataSvg,
  alt: {
    Icon__small: Icon__small__dataSvg,
    Icon__xsmall: Icon__xsmall__dataSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
